import React, { useEffect, useState } from "react";
import ProfilePlaceHolder from "../../../assets/ProfilePlaceHolder.png";
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
export default function BookClassModal({
  cancelModal,
  selectedBooking,
  products,
  refresh,
}) {
  const { user } = useAuthContext();
  const [dayOfWeek, setDayOfWeek] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  //styled
  const [profiles, setProfiles] = useState([]);

  const [bookedProfiles, setBookedProfiles] = useState([]);

  const [noneBookedUsers, setNoneBookedUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const [confirmBooking, setConfirmBooking] = useState(false);
  const [bookingComplete, setBookingComplete] = useState(false);
  const [token, setToken] = useState([]);

  const [selectedProfile, setSelectedProfile] = useState([]);
  const [profileImage, setProfileImage] = useState(false);

  const [requestCancel, setRequestCancel] = useState(false);
  const [warning, setWarning] = useState("");

  const handleBookAndBuy = async () => {
    const bookAndBuy = {
      productId: selectedBooking.stripeProductId,
      eventId: selectedBooking.eventId,
      bookingProfileId: selectedUserId,
      date: selectedBooking.date,
    };

    const transResponse = await axios.post(
      `${ApiConnectionString}/Api/Checkout/BuyAndBook`,
      bookAndBuy,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );
    if (transResponse.status === 200) {
      window.location.href = transResponse.data;
    }
  };

  useEffect(() => {
    const fetchProfileImage = async () => {
      if (selectedUser) {
        try {
          const response = await axios.get(
            `${ApiConnectionString}/api/profileImage/${selectedUser.id}`
          );
          // handle the response, for example, storing it in state
          if (response.status == 200 && response.data) {
            if (response.data != null) {
              setProfileImage(true);
            }
          }
        } catch (error) {
          console.error("Error fetching profile image:", error);
        }
      }
    };

    fetchProfileImage();
  }, [selectedUser]);

  useEffect(() => {
    if (selectedBooking?.date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to today's date at 12 AM
      const bookingDate = new Date(selectedBooking.date);

      if (bookingDate < today) {
        setWarning(
          `Please note: This class occurred on ${new Date(
            selectedBooking.date
          ).toLocaleDateString()}
          . Only proceed with booking if you physically attended the session on that date.`
        );
      }
    }

    if (selectedBooking && selectedBooking.date) {
      const date = new Date(selectedBooking.date);
      const dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      setDayOfWeek(dayNames[date.getDay()]);
    }
  }, [selectedBooking]);

  const handleCancelRequest = async () => {
    const updatebooking = {
      id: selectedProfile.bookingId,
    };
    const updateBookingResponse = await axios.put(
      `${ApiConnectionString}/api/booking`,
      updatebooking,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (updateBookingResponse.status == 200) {
      setRequestCancel(false);
    } else {
      //handle
    }
  };

  const getUserById = (id) => {
    return noneBookedUsers.find((user) => user.id == id);
  };

  const handleBookWithSub = async () => {
    const createBooking = {
      eventId: selectedBooking.eventId,
      bookingProfileId: selectedUserId,
      date: selectedBooking.date,
    };

    const bookingResponse = await axios.post(
      `${ApiConnectionString}/api/bookingSubscription`,
      createBooking,
      {
        headers: { Authorization: `bearer ${user.token}` },
      }
    );

    if (bookingResponse.status == 200) {
      setBookingComplete(true);
      setConfirmBooking(false);
          setSelectedUserId("")
        // setSelectedUser(null);
    }
  };

  const handleBookWithTokens = async (productId) => {
    setIsLoading(true);
    try {
      const createBooking = {
        eventId: selectedBooking.eventId,
        bookingProfileId: selectedUserId,
        date: selectedBooking.date,
        productId,
      };

      const bookingResponse = await axios.post(
        `${ApiConnectionString}/api/BookingTokens`,
        createBooking,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (bookingResponse.status === 200) {
        setBookingComplete(true);
        setConfirmBooking(false);

        setSelectedUserId("")
        // setSelectedUser(null);
      }
    } catch (error) {
      console.error("Booking failed:", error);
      // You can also show an error message to the user if you want
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const tokenResponse = await axios.get(
        `${ApiConnectionString}/api/Token/${selectedBooking.clubId}/${selectedBooking.eventId}`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );
      setToken(tokenResponse.data);
      const response = await axios.get(
        `${ApiConnectionString}/api/BookingProfilesForEvent?AppUserId=${user.id}&ClubId=${selectedBooking.clubId}&EventId=${selectedBooking.eventId}&FromDateTime=${selectedBooking.date}`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );
      setProfiles(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error if necessary
    }
  };

  useEffect(() => {
    setConfirmBooking(false);
    fetchData();
  }, [bookingComplete, cancelModal, requestCancel, user]);

  useEffect(() => {
    // Filter profiles into bookedProfiles and noneBookedUsers based on isBooked
    const booked = profiles.filter((profile) => profile.isBooked);

    const noneBooked = profiles.filter((profile) => !profile.isBooked);

    setBookedProfiles(booked);
    setNoneBookedUsers(noneBooked);
  }, [profiles, bookingComplete, cancelModal, user]);

  const handleSelectUser = (e) => {
    setSelectedUserId(e.target.value);
  };

  const handleSelectButtonClick = () => {
    setSelectedUser(getUserById(selectedUserId));
    setConfirmBooking(true);
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />

          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (bookingComplete) {
      return (
<div className="class-booking-modal-overlay">
  <div className="class-booking-modal text-center p-4 rounded shadow">
    <h1 className="fw-bold mb-4">Booking</h1>

    <div className="d-flex justify-content-center mb-3 mt-5">
      <div className="bg-success rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
        <span className="text-white fs-3">✓</span>
      </div>
    </div>

    <p className="mb-4">
      <strong>{selectedUser.username}</strong> has been successfully booked into{" "}
      <strong>{selectedBooking.name}</strong> on{" "}
      <strong>{new Date(selectedBooking.date).toLocaleDateString()}</strong> at{" "}
      <strong>{selectedBooking.timeIn} – {selectedBooking.timeOut}</strong>.
    </p>

    <div>
      <button
        className="saveChanges-button"
        onClick={() => {
          setBookingComplete(false);
          refresh();
        }}
      >
        Okay
      </button>
    </div>
  </div>
</div>
      );
    } else {
      if (confirmBooking) {
  return (
  <div className="class-booking-modal-overlay">
    <div className="class-booking-modal text-center p-4 bg-white rounded shadow-sm">
      <button
        type="button"
        className="btn-close position-absolute top-0 end-0 m-3"
        onClick={cancelModal}
        aria-label="Close"
      ></button>

      <h1 className="fw-bold mb-3">Booking</h1>

      <div className="d-flex justify-content-center mb-2">
        <img
          src={
            profileImage
              ? `${ApiConnectionString}/api/profileImage/${selectedUser.id}`
              : ProfilePlaceHolder
          }
          alt="Profile"
          width={140}
          className="rounded-circle mb-2"
        />
      </div>

      <h5 className="fw-bold">{selectedUser.username}</h5>

      <p className="mb-4">
        You have selected the profile <strong>{selectedUser.username}</strong> to be booked into the class <strong>{selectedBooking.name}</strong><br />
        Scheduled from <strong>{selectedBooking.timeIn} – {selectedBooking.timeOut}</strong> on <strong>{new Date(selectedBooking.date).toLocaleDateString()}</strong>.
      </p>

      {!selectedUser.isSubscribed && token.length > 0 && (
        <>
          <p className="text-muted mb-3">
            Use a class token to book this class. One token will be deducted.
          </p>
          {token.map((item) => (
            <div className="d-flex justify-content-between align-items-center border rounded p-3 mb-3 container mx-5 px-5" key={item.id}>
              <div>
                <div className="fw-bold">{item.viewProduct.name}</div>
                <div><span className="text-danger">Classes Amount:</span> {item.tokenAmount}</div>
              </div>
              {item.tokenAmount > 0 && (
                <button
                  className="btn btn-primary"
                  disabled={isLoading}
                  onClick={() => handleBookWithTokens(item.viewProduct.id)}
                >
                  Book In
                </button>
              )}
            </div>
          ))}
        </>
      )}

      {!selectedUser.isSubscribed && token.length === 0 && (
        <p className="text-danger">
          {selectedUser.username} does not have an active subscription or class tokens to book this class.
        </p>
      )}

      {selectedUser.isSubscribed && selectedUser.hasAccess && (
        <>
          <p className="fw-bold">You can book this class using your subscription</p>
          <p className="text-muted">
            {selectedUser.username} has access through the subscription <strong>{selectedUser.productName}</strong>.
          </p>
          <div className="my-3">
            <button className="btn btn-primary" onClick={handleBookWithSub}>
              Book In
            </button>
          </div>
        </>
      )}

      {selectedUser.isSubscribed && !selectedUser.hasAccess && (
        <>
          <p className="text-warning">
            Your subscription does not cover this event. You can use class tokens instead.
          </p>
          <p className="text-muted">
            Use a class token to book this class. One token will be deducted.
          </p>
          {token.map((item) => (
            <div className="d-flex justify-content-between align-items-center border rounded p-3 mb-3" key={item.id}>
              <div>
                <div className="fw-bold">{item.viewProduct.name}</div>
                <div><span className="text-danger">Classes Amount:</span> {item.tokenAmount}</div>
              </div>
              {item.tokenAmount > 0 && (
                <button
                  className="btn btn-primary"
                  onClick={() => handleBookWithTokens(item.viewProduct.id)}
                >
                  Book In
                </button>
              )}
            </div>
          ))}
        </>
      )}

      <hr className="my-4" />

      {selectedBooking.price && (
        <p className="text-muted">
          If you'd like to book this class without using a subscription or token, you can purchase it for £
          {selectedBooking.price / 100} by clicking{' '}
          <Link onClick={handleBookAndBuy}>Book and Buy</Link>.
        </p>
      )}

      <div className="mt-4">
        <button onClick={cancelModal} className="btn btn-outline-dark fw-bold px-4">
          Cancel
        </button>
      </div>
    </div>
  </div>
);

      } else {
        if (!requestCancel) {
          return (
            <div className="class-booking-modal-overlay">
              <div className="class-booking-modal">
                <button
                  type="button"
                  className="close-button"
                  onClick={cancelModal}
                  aria-label="Close"
                >
                  &times;
                </button>

                <h1 className="fw-bold">Booking</h1>

                <div>
                  <div className="day-date-box text-center rounded text-white p-4">
                    <p className="m-0 p-0 fw-bold">{dayOfWeek}</p>
                    <p className="m-0 p-0">
                      {new Date(selectedBooking.date).toLocaleDateString()}
                    </p>
                  </div>

                  <div>
                    <div className="text-center">
                      <h3>{selectedBooking.name}</h3>
                      <p className="my-0">{selectedBooking.description}</p>
                      <p>
                        {String(selectedBooking.timeIn)
                          .padStart(4, "0")
                          .replace(/(\d{2})(\d{2})/, "$1:$2")}{" "}
                        -
                        {String(selectedBooking.timeOut)
                          .padStart(4, "0")
                          .replace(/(\d{2})(\d{2})/, "$1:$2")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="send-modal-content">
                  {warning && <p className="text-danger">{warning}</p>}

                  {bookedProfiles.length > 0 && (
                    <div>
                    
                      <p className="text-muted mt-0">
                        You have currently booked the following profiles into
                        this class.
                      </p>
                      <ul className="list-unstyled">
                        {bookedProfiles.map((profile) => (
                          <li
                            key={profile.id}
                            className="d-flex align-items-center"
                          >
                            <span className="username-container">
                              {profile.username}
                            </span>
                            {profile.cancelPending && (
                              <p className="text-danger">Cancel Pending</p>
                            )}
                            <Dropdown>
                              <Dropdown.Toggle
                                as="span"
                                id="dropdown-custom-components"
                                className="dropdown-toggle-custom"
                              >
                                <ThreeDotsVertical
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setSelectedProfile(profile)}
                                />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {!selectedProfile.cancelPending && (
                                  <Dropdown.Item
                                    eventKey="1"
                                    onClick={() => setRequestCancel(true)}
                                  >
                                    Request to cancel this booking.
                                  </Dropdown.Item>
                                )}

                                {selectedProfile.cancelPending && (
                                  <Dropdown.Item
                                    eventKey="1"
                                    onClick={() => setRequestCancel(true)}
                                  >
                                    Re-book onto this class.
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </li>
                        ))}
                      </ul>
                      <hr />
                    </div>
                  )}

                  {!selectedBooking.fullyBooked ? (
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                         {noneBookedUsers.length > 0 ?        <div className="mb-3">          <p className="text-muted mb-0">
                            Select a profile to book in.
                          </p>

         
                            <select
                              className="form-select mb-2"
                              value={selectedUserId}
                              onChange={handleSelectUser}
                            >
                              <option value="">Select Profile...</option>
                              {noneBookedUsers.map((user) => (
                                <option key={user.id} value={user.id}>
                                  {user.username}
                                </option>
                              ))}
                            </select>

                            <button
                              className="btn btn-primary w-100"
                              onClick={handleSelectButtonClick}
                              disabled={selectedUserId == ""}
                            >
                              Book In
                            </button>
                          </div> : <p>All your profiles are booked into this class.</p>}

                          <p className="text-muted small">
                            To book additional individuals into the same class,
                            you can create a separate profile under{" "}
                            <Link to="/myprofile">My Profiles</Link>. This
                            allows you to book on behalf of family members, such
                            as your children or spouse, or anyone you share your
                            account with.
                          </p>


                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="text-danger fw-bold text-center">
                      Fully booked
                    </p>
                  )}
                </div>
                <div className="send-modal-footer">
                  <button
                    onClick={cancelModal}
                    className="pointer cancelButton fw-bold mx-2 px-3"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          );
        } else {
          return (
               <div className="class-booking-modal-overlay">
      <div className="class-booking-modal">
                <div className="blueBanner">
                  <p className="fw-bold m-2 p-2 fontSize20">
                    {" "}
                    {!selectedProfile.cancelPending
                      ? "Cancel booking"
                      : "Re-book"}
                  </p>
                </div>

                <button
                  type="button"
                  className="close-button"
                  onClick={cancelModal}
                  aria-label="Close"
                >
                  &times;
                </button>

                <p>
                  {!selectedProfile.cancelPending
                    ? "Please confirm that you want to request to cancel this booking"
                    : "Please confirm that you want to request to re-book onto this booking"}
                </p>

                <div className="send-modal-footer">
                  <button
                    className="delete-button mx-3"
                    onClick={handleCancelRequest}
                  >
                    Confirm
                  </button>
                  <button
                    onClick={cancelModal}
                    className="pointer cancelButton fw-bold mx-2 px-3"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          );
        }
      }
    }
  }
}
